import LogoIconWhiteSahibinden from '@/components/sahibinden/Icons/icons-generated/LogoIconWhiteSahibinden';
import { SahibindenLogo } from '@/components/sahibinden/SahibindenLogo';
import { SahibindenSsoModal } from '@/features/sahibinden/auth/SahibindenSsoModal';

import { type VariantSettings } from './variantConfiguration';

export const sahibindenConfig: VariantSettings = {
  WebsiteName: 'Sahibinden.com',
  Logo: <SahibindenLogo />,
  LogoIconWhite: <LogoIconWhiteSahibinden fontSize={36} boxSize={9} />,
  SsoModal: <SahibindenSsoModal />,
};
